var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  };
import * as React from "react";
import { useUID } from "@twilio-paste/uid-library";
import { IconWrapper } from "@twilio-paste/icons/esm/helpers/IconWrapper";
import { useTheme } from "@twilio-paste/theme";
import { isIconSizeTokenProp } from "@twilio-paste/style-props";
import { styled } from "@twilio-paste/styling-library";
import { keyframes } from "@twilio-paste/styling-library";
var circleGeometry = {
    cx: 50,
    cy: 50,
    r: 45
  },
  circleCircumference = Math.PI * 2 * 45;
var SvgKeyframes = keyframes`
  0%,
  15% {
    stroke-dashoffset: ${circleCircumference * .9999};
    transform: rotate(0);
  }

  50%,
  75% {
    stroke-dashoffset: ${circleCircumference * .2};
    transform: rotate(45deg);
  }

  100% {
    stroke-dashoffset: ${circleCircumference * .9999};
    transform: rotate(360deg);
  }
`,
  CircleKeyframes = keyframes`
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
`;
var StyledCircleTrack = styled.circle({
    transformOrigin: "center",
    opacity: .25
  }),
  AnimatedStyledCircle = styled.circle(_ref => {
    let {
      show
    } = _ref;
    return {
      transformOrigin: "center",
      animation: `1.5s ease-in-out infinite both ${CircleKeyframes}`,
      strokeDasharray: circleCircumference,
      opacity: show ? 1 : 0
    };
  }),
  StyledSvg = styled.svg({
    height: "100%",
    width: "100%",
    display: "block",
    animation: `4.25s linear infinite both ${SvgKeyframes}`
  });
var Spinner = React.forwardRef((_ref2, ref) => {
  let {
    size,
    color = "currentColor",
    title,
    as,
    display,
    decorative,
    delay = 250,
    element = "SPINNER"
  } = _ref2;
  let titleId = `spinner-${useUID()}`,
    {
      borderWidths: {
        borderWidth40
      }
    } = useTheme(),
    [show, setShow] = React.useState(delay === 0);
  if (!decorative && title == null) throw new Error("[Spinner]: Missing a title for non-decorative icon.");
  return React.useEffect(() => {
    if (delay === 0) return;
    let showTimer = setTimeout(() => setShow(!0), delay);
    return () => clearTimeout(showTimer);
  }, [delay]), React.createElement(IconWrapper, {
    as,
    element,
    display,
    size,
    color,
    "aria-hidden": decorative,
    ref
  }, React.createElement(StyledSvg, {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    strokeWidth: borderWidth40,
    stroke: "currentColor",
    strokeLinecap: "round",
    fill: "transparent"
  }, React.createElement(StyledCircleTrack, __spreadValues({}, circleGeometry)), React.createElement(AnimatedStyledCircle, __spreadValues({
    show
  }, circleGeometry)))));
});
Spinner.displayName = "Spinner";
export { Spinner };